import React from "react";
export default () => (
    <p>
        Pro Download allows you to customize this icon and not have to worry
        about giving credit. Your payment directly supports the creator.
    </p>
);
